import { createContext } from "react";
import useTenants from "../hooks/data/useTenants";

export interface ITenantsContext extends ReturnType<typeof useTenants> {

};

const TenantsContext = createContext<ITenantsContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default TenantsContext